import { render, staticRenderFns } from "./ActivityRanking.vue?vue&type=template&id=8ce449f2&scoped=true&"
import script from "./ActivityRanking.vue?vue&type=script&lang=js&"
export * from "./ActivityRanking.vue?vue&type=script&lang=js&"
import style0 from "./ActivityRanking.vue?vue&type=style&index=0&id=8ce449f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce449f2",
  null
  
)

export default component.exports